export default function processMobileNumber(mobile: string | null = '') {
  if (typeof mobile === 'string') {
    return mobile.replace(/[\s()]/g, '');
  }

  return mobile;
}
